import { IoIosCheckmarkCircleOutline } from "react-icons/io";

import "./index-about.css";
import Button from "../../../components/elements/button";
import { ButtonHref } from "../../../components/elements/button";
import CTA from "../../../components/elements/CTA"

function CorrecaoSection() {
  return (
    <section className="correction section">
      <div className="container">
        <div className="correction-box">
          <div className="correction-images">
            <div className="paper paper-one">
              <div className="fake-lines">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>

            <div className="paper paper-two">
              <div className="fake-lines">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>

            <div className="feedback-note">
              <strong>Feedback</strong>

              <p>✓ Texto pouco claro</p>

              <p>✓ Desenvolver melhor os argumentos</p>

              <p>✓ Evitar repetição de ideias</p>

              <p>✓ Concluir com proposta de intervenção completa</p>
            </div>
          </div>

          <div className="correction-content">
            <span className="eyebrow">CORREÇÕES QUE TRANSFORMAM</span>

            <h2>
              Correção de redações
              <br />
              com feedback individual
            </h2>

            <p>
              Você não recebe apenas uma nota.
              <br />
              Você entende onde errou, por quê e como melhorar.
            </p>

            <ul className="correction-check-list">
              <li>
                <IoIosCheckmarkCircleOutline className="ep-icon-check-mark"/>
                Análise completa por competência
              </li>

              <li>
                <IoIosCheckmarkCircleOutline className="ep-icon-check-mark"/>
                Comentários linha a linha
              </li>

              <li>
                <IoIosCheckmarkCircleOutline className="ep-icon-check-mark"/>
                Dicas personalizadas
              </li>

              <li>
                <IoIosCheckmarkCircleOutline className="ep-icon-check-mark"/>
                Sugestões de melhoria prática
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

function SobreProfessora() {
  return (
    <section id="sobre-a-professora" className="teacher section">
      <div className="container">
        <div className="teacher-content">
          <div className="teacher-photo-wrapper">
            <img
              src="/images/professora.jpg"
              alt="Professora Iasmyn Souza Louis"
              className="teacher-photo"
            />
          </div>

          <div className="teacher-info">
            <div className="section-heading left">
              <h2>Sobre a professora</h2>
              <span></span>
            </div>

            <h3>Profª Iasmyn Souza Louis</h3>

            <p>
              Mestre em Ensino (UFF) e apaixonada pelo ensino da língua
              portuguesa. Atua há anos ajudando alunos a desenvolverem uma
              escrita clara, coerente e eficaz para conquistarem seus objetivos
              no ENEM, concursos e vestibulares.
            </p>

            <div className="teacher-stats">
              <div className="teacher-stat">
                <div className="stat-icon">🎓</div>

                <strong>
                  Formação
                  <br />
                  sólida
                </strong>
              </div>

              <div className="teacher-stat">
                <div className="stat-icon">♙</div>

                <strong>
                  Metodologia
                  <br />
                  comprovada
                </strong>
              </div>

              <div className="teacher-stat">
                <div className="stat-icon">♧</div>

                <strong>
                  Centenas de
                  <br />
                  alunos aprovados
                </strong>
              </div>
            </div>
          </div>

          <div className="teacher-quote">
            <span className="quote-symbol">“</span>

            <p>
              Ensinar é acreditar no potencial de cada aluno e guiá-lo até a sua
              melhor versão.
            </p>

            <div className="signature">Iasmyn Souza</div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Solucoes() {
  const solutions = [
    {
      icon: "▣",
      title: "Aulas Online",
      text: "Videoaulas objetivas, materiais completos e exercícios práticos.",
      href: "/mentorias-individuais"
    },
    {
      icon: "✎",
      title: "Correções ENEM",
      text: "Correções de redação no padrão ENEM com feedback individual.",
      href: "/redacao-enem"
    },
    {
      icon: "▣",
      title: "Correções para Concursos",
      text: "Textos dissertativos e práticos corrigidos com foco nos critérios dos editais.",
      href: "/correcoes-para-concursos"
    },
    {
      icon: "♜",
      title: "Redação para Vestibulares",
      text: "Produção textual voltada para vestibulares tradicionais e específicos.",
      href: "/producao-textual-para-vestibulares"
    },
  ];

  return (
    <section className="solutions section">
      <div className="container">
        <div className="solutions-box">
          <div className="section-heading">
            <h2>Nossas soluções para sua escrita</h2>
            <span></span>
          </div>

          <div className="solutions-grid">
            {solutions.map((solution) => (
              <div className="solution-card" key={solution.title}>
                <div className="solution-icon">{solution.icon}</div>

                <h3>{solution.title}</h3>

                <p>{solution.text}</p>

                <ButtonHref href={solution.href}> SAIBA MAIS </ButtonHref>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default function LandingPage() {
  return (
    <>
      <CorrecaoSection />

      <SobreProfessora />

      <Solucoes />

      <CTA />
    </>
  );
}
